export function eqeq(a: number | string | None, b: number | string): boolean {
  return a == b
}
